import { Component, OnInit, HostBinding, HostListener } from '@angular/core';
import { TITLES } from '../../../assets/data';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  title = TITLES;
  isFixedNavbar;
  showFiller = false;
  constructor() {
   }

  @HostBinding('class.navbar-opened') navbarOpened = false;

  ngOnInit() {
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (offset > 50) {
      this.isFixedNavbar = true;
    } else {
      this.isFixedNavbar = false;
    }
  }

  toggleNavbar() {
    this.navbarOpened = !this.navbarOpened;
    window.scrollTo(0, 0);
  }

}
